export const TEXT_VARIANTS = {
    _12: '12',
    _12_BOLD: '12-bold',
    _14: '14', // default
    _14_BOLD: '14-bold',
    _16: '16',
    _16_BOLD: '16-bold',
    _18_EMPHASIZED: '18-emphasized',
    _24_EMPHASIZED: '24-emphasized',
    _28_EMPHASIZED: '28-emphasized',
    _32_EMPHASIZED: '32-emphasized',
};
export const TEXT_COLORS = {
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    BLACK: 'black',
    WHITE: 'white',
};
